import React from "react";
import SettingJobTable from "./components/SettingJobTable";

const SettingJob = () => {
  return <SettingJobTable />;
};

export default SettingJob;
